import { useDispatch, useSelector } from "react-redux";
import { postFetchData } from "../../../utils/api/FetchData";
import { useCallback, useEffect, useRef } from "react";

const CustomHookForFilter = () => {
  const dispatch = useDispatch();
  const districtDetails = useSelector((state: RootState) => state.district);

  const latestSelectorData = useRef(districtDetails);
  useEffect(() => {
    latestSelectorData.current = districtDetails; // Update latest state when Redux changes
  }, [districtDetails]);

  const DistrictDetailsHandleChange = useCallback(
    async (
      name,
      values,
      url,
      fun

      // selectedCodeFun
    ) => {
      //  dispatch(fun(values));

      const requestData = {
        region_code: latestSelectorData.current?.region_code,
        district_code:
          // districtDetails?.district_code
          latestSelectorData.current?.district_code,
        division_code: latestSelectorData.current?.division_code,
        // taluk_code: latestSelectorData.current?.taluk_code,
        taluk_code: [],

        village_code: latestSelectorData.current?.village_code,
      };

      details(url, requestData, fun);
    },
    [latestSelectorData, dispatch]
  );

  const details = async (url, requestData, fun, selectedCodeFun) => {
    const response = await postFetchData(1, dispatch, url, requestData ?? []); // Use dynamic API URL
    if (response?.status === 1) {
      if (response?.data?.length !== 0) {
        await dispatch(fun([{ id: "0", name: "All" }, ...response?.data]));

        if (requestData?.length == 0) {
          if (selectedCodeFun) {
            await dispatch(
              selectedCodeFun(response?.data?.map((item: any) => item.id))
            );
          }
        }
      }
    }
  };

  return { DistrictDetailsHandleChange, details };
};

export default CustomHookForFilter;
